import React, { useEffect, useState } from "react";
import { ConnectionsTable, ConnectionsToolbar } from "../../Components";
import { useBreadcrumb } from "app/components/Breadcrumbs";
import { DivStyled } from "./ConnectionsListPage.styles";
import { useConnectionsSearchQuery } from "app/hooks/api";
import { useStoreSelector } from "app/store";
const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;
const ConnectionsListPage = () => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("connectionName");
  const [sortOrder, setSortOrder] = useState("asc");
  const ownerId = useStoreSelector((state) => state.AppReducer.environment.ownerId);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
      setPage(DEFAULT_PAGE);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);
  const { data, isFetching } = useConnectionsSearchQuery({
    variables: {
      page,
      pageSize,
      searchQuery: debouncedSearchQuery,
      sortBy,
      sortOrder,
      ownerId
    }
  });
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };
  const handleRowsPerPageChange = (event) => {
    setPageSize(event.target.value);
    setPage(DEFAULT_PAGE);
  };
  const handleSortChange = ({ sortBy: newSortBy, sortOrder: newSortOrder }) => {
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    setPage(DEFAULT_PAGE);
  };
  useBreadcrumb("menu.connections", {
    hideTrail: true,
    hideTitle: true,
    otherElements: /* @__PURE__ */ React.createElement(
      ConnectionsToolbar,
      {
        handleSearch,
        totalCount: isFetching ? void 0 : data?.totalItems,
        initialSearchQuery: searchQuery
      }
    )
  });
  return /* @__PURE__ */ React.createElement(DivStyled, null, /* @__PURE__ */ React.createElement(
    ConnectionsTable,
    {
      onPageChange: handlePageChange,
      onRowsPerPageChange: handleRowsPerPageChange,
      connections: data?.items ?? [],
      page: page - 1,
      rowsPerPage: pageSize,
      totalCount: data?.totalItems ?? 0,
      loading: isFetching,
      onSortChange: handleSortChange
    }
  ));
};
export default ConnectionsListPage;
